import { IAppState } from './appState';
import { TgvSubprodukt } from './models/tgvSubprodukt';
import { createTier } from './models/tier';

export const INITIAL_STATE: IAppState = {
  version: 1,
  antragsnummer: null,
  gesamtbeitrag: null,
  savedGesamtbeitragMitRabatt: null,
  savedJahresbeitragMitRabatt: null,
  gesamtbeitragMitRabatt: null,
  jahresbeitrag: null,
  produkt: null,
  rabattstufe: null,
  taasInfo: null,
  vertragsoptionen: null,
  transientState: {
    zurueckZumShopModalOpen: false,
    role: null,
    featureToggles: {},
    regexps: {},
    tarifierungIsInProgress: false,
    priceGuarantee: false,
    fehlerCodeTaas: '',
    kooperationen: null,
    showErrors: false,
    takeOverRunning: false,
    eingabeTarget: null,
    katalogError: false,
    juristisch: false,
    runFailure: null,
    pricingIssue: null,
    produkte: [],
    katalog: {
      dogBreeds: [],
      horseBreeds: [],
      catBreeds: [],
      thhDogBreeds: [],
      thhHorseBreeds: [],
      animalIllnesses: null,
    },
    children: { creating: [], pendingDeletion: [], registryVersion: 0 },
    pricing: {},
    angebot: {
      current: null,
      editedKey: null,
      visited: [],
      summaryExpanded: false,
      adoptionError: false,
      copyInProgress: false,
    },
  },
  tiergruppe: {
    selectedSubprodukt: TgvSubprodukt.TKV_V2,
    positions: {
      tkvV2: [],
      thhHund: null,
      thhPferd: null,
    },
    tiere: [createTier('tier-0')],
    vorschaeden: {
      thhHund: { vorhanden: null, anzahl: 0 },
      thhPferd: { vorhanden: null, anzahl: 0 },
    },
    kunde: { plz: '', ort: '', strasse: '', hausnummer: '', geburtsdatum: '' },
    angebotsIds: {},
    thhAngelegt: { thhHund: false, thhPferd: false },
    thhVorvertrag: { thhHund: null, thhPferd: null },
    uebernommen: [],
    deferredDeletion: [],
  },
};
